import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children, permission, permissions }) => {
  const { isAuthenticated, loading, hasPermission, hasAnyPermission, securityStatus } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress size={48} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to forced password change pages — skip if already there
  const isPasswordPage = location.pathname === '/password-expired';
  if (!isPasswordPage && securityStatus) {
    if (securityStatus === 'PASSWORD_EXPIRED' || securityStatus === 'FORCE_PASSWORD_RESET') {
      return <Navigate to="/password-expired" replace state={{ forceReset: securityStatus === 'FORCE_PASSWORD_RESET' }} />;
    }
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/403" replace />;
  }
  if (permissions && !hasAnyPermission(permissions)) {
    return <Navigate to="/403" replace />;
  }

  return children ?? <Outlet />;
};

export default ProtectedRoute;
